<div class="s__table-block" [class.s__table-block--striped]="striped()" [class.s__table-block--compact]="compact()">
  <div class="s__table-block__scroll-wrap">
    <table class="s__table-block__table">
      <thead>
        <tr>
          @for (header of data().headers; track $index) {
            @if (isString(header)) {
              <th class="s__table-block__th">{{ header }}</th>
            } @else {
              <th class="s__table-block__th" [innerHTML]="header.text"></th>
            }
          }
        </tr>
      </thead>
      <tbody>
        @for (row of data().rows; track $index) {
          <tr class="s__table-block__tr">
            @for (cell of row; track $index) {
              @if (isString(cell)) {
                <td class="s__table-block__td">{{ cell }}</td>
              } @else {
                <td class="s__table-block__td" [ngClass]="getCellClasses(cell)">
                  @if (cell.image) {
                    <div class="s__table-block__td-content">
                      <img [src]="cell.image" [alt]="cell.imageAlt || ''" class="s__table-block__td-img" loading="lazy" decoding="async" />
                      @if (cell.text) {
                        <span [innerHTML]="cell.text"></span>
                      }
                    </div>
                  } @else {
                    <span [innerHTML]="cell.text"></span>
                  }
                </td>
              }
            }
          </tr>
        }
      </tbody>
    </table>
  </div>
  @if (data().footnotes?.length) {
    <div class="s__table-block__footnotes">
      @for (note of data().footnotes; track $index) {
        <div class="s__table-block__footnote" [innerHTML]="note"></div>
      }
    </div>
  }
</div>
